/* eslint-disable @typescript-eslint/no-explicit-any */
import { useUIStore } from "@/stores";
import {
  Backdrop,
  Box,
  Fade,
  Modal as MUIModal,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { ModalComponentProps } from "./modal.types";

const Modal: FC<ModalComponentProps> = ({
  title,
  children,
  onClose,
  isOpened,
}) => {
  const { modal, closeModal: modalOnClose } = useUIStore();

  const ModalBody = modal.component;

  if (!children && !ModalBody) return null;

  return (
    <MUIModal
      open={isOpened ?? modal.isOpened}
      onClose={onClose ?? modalOnClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{ backdrop: { timeout: 300 } }}
    >
      <Fade in={isOpened ?? modal.isOpened} timeout={300}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "#121212",
            borderRadius: 3,
            boxShadow: 24,
            p: 2,
            textAlign: "center",
          }}
        >
          <Typography variant="h5" sx={{ mb: 3, color: "white" }}>
            {title || modal.data.title}
          </Typography>

          {children || (ModalBody && <ModalBody {...(modal.data as any)} />)}
        </Box>
      </Fade>
    </MUIModal>
  );
};

export { Modal };
